import React from "react"
import { ArrowPathIcon, WifiIcon } from "@heroicons/react/24/outline"
import Button from "aldoo-ra/Button"
import useT from "../hooks/useT"

// what a request that never reached the server says (axios "Network Error", fetch "Failed to fetch")
export const isNetworkError = (error) => /network error|failed to fetch|load failed|networkerror|timeout/i.test(String(error?.message || error || ""))

/**
 * Something could not be loaded: said in the middle of the space it was to fill, with a way to try
 * again — a connection lost (the server down a moment, the phone offline) is said as such, not as
 * the raw "Network Error"; another failure says its own words.
 */
export default function RetryPanel({ error, message, onRetry, busy = false, className = "" }) {
  const t = useT()
  const network = isNetworkError(error)
  return (
    <div className={`flex flex-col items-center justify-center gap-4 py-10 px-4 text-center ${className}`} role="alert" data-testid="retry-panel">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-neutral">
        <WifiIcon className="w-7 h-7 text-text_secondary" aria-hidden="true" />
      </span>
      <div className="flex flex-col gap-1">
        <span className="text-[17px] font-semibold">{network ? t`We could not reach the server` : t`Something went wrong`}</span>
        <span className="text-[14px] text-text_secondary max-w-[360px]">{message || (network ? t`Check your connection and try again.` : t`Please try again`)}</span>
      </div>
      {onRetry && (
        <Button variant="primary" onClick={onRetry} disabled={busy} data-testid="retry-button">
          <span className="flex items-center gap-2">
            <ArrowPathIcon className={`w-5 h-5 ${busy ? "animate-spin" : ""}`} aria-hidden="true" />
            {t`Try again`}
          </span>
        </Button>
      )}
    </div>
  )
}
